import "./intro.css";

const Intro = () => {
  return (
    <div className="i">
      <div className="i-left">
        <div className="i-left-wrapper">
          <h2 className="i-intro">Hello, My name is</h2>
          <h1 className="i-name">Courage Yesin</h1>
          <div className="i-title">
            <div className="i-title-wrapper">
              <div className="i-title-item">Frontend Developer</div>
             
           </div>
          </div>
          <p className="i-desc">
         I am a Freelance Frontend Web Developer who specializes in HTML5,CSS3
                             and JavaScript usage as well as Git and Github. I design websites and create web applications.
          </p>
        </div>
       
      </div>
      <div className="i-right">
        <div className="i-bg"></div>
       
      </div>
    </div>
  );
};

export default Intro;